import React, { useEffect, useState } from 'react';

import styled from '@emotion/styled';

import BarChart from '../../../../components/Charts/BarChart';
import ChartFilter from '../../../../components/Charts/ChartFilter/ChartFilter';
import PerformanceHistoryLegend from '../../../../components/Charts/CustomLegends/PerformanceHistoryLegend';
import PerformanceHistoryTooltip from '../../../../components/Charts/CustomToolTips/PerformanceHistoryTooltip';
import usePerformanceInsight from '../../../../hooks/dashboard/driver-list/usePerformanceInsight';

const PerformanceHistory = ({ baseUrl }: { baseUrl: string }) => {
  const [dataUrl, setDataUrl] = useState<string>(baseUrl);

  const {
    getPerformanceDataInsight,
    // loading,
    PerformanceInsightData,
  } = usePerformanceInsight();

  useEffect(() => {
    if (!dataUrl) return;

    getPerformanceDataInsight(dataUrl);
    // eslint-disable-next-line
  }, [dataUrl]);

  return (
    <Container>
      <HeaderArea>
        <Header>Performance History</Header>

        <ControlArea>
          <ChartFilter
            setDataUrl={setDataUrl}
            dataUrl={dataUrl}
            variant='yearMonth'
          />
        </ControlArea>
      </HeaderArea>

      <Container>
        <BarChart
          xAxisDataKey='dayLabel'
          data={PerformanceInsightData}
          isAnimationActive={true}
          dataKeys={['weightedScore']}
          fills={['#5B91F5']}
          showLegend={false}
          aspect={3}
          tooltipLabel={['Performance Score']}
          externalTooltip={{
            content: (
              <PerformanceHistoryTooltip tooltipLabel={['Average Weight']} />
            ),
            cursor: { fill: 'rgba(0, 0, 0, 0.05)' },
          }}
          yLabel='Weighted average per day (%)'
        />

        <PerformanceHistoryLegend label='Days in the month' />
      </Container>
    </Container>
  );
};

export default PerformanceHistory;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 24px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
`;

const ControlArea = styled.div`
  display: flex;
`;

const HeaderArea = styled.div`
  font-weight: 600;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  /* border: 1px solid red; */
  margin-bottom: 18px;
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 18px;
`;
